import React from 'react';

import Container from './Container';
import CodeDescription from './CodeDescription';
import QuestionIcon from './QuestionIcon';

export default ({ cardType, minimal }) => (
  <Container minimal={minimal}>
    <QuestionIcon name="question-circle" />
    <CodeDescription type={cardType} />
  </Container>
);
